// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"uT-z","sponsoredTooltipWrapper":"vT-z","sponsoredTooltip":"wT-z","newCard":"xT-z"};